// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3qyqB","buttons":"RemoveExpirationActionButtons_buttons__FZcvg"};